export default __webpack_public_path__ + "static/media/sc1.7e10b84d.jpg";